import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import modules from '../modules';
import { useAuth } from '../hooks/useAuth';

interface Props {
  children: any;
  moduleConfig?: any;
}

export default function Layout({
  moduleConfig,
  children,
}: Props): ReactElement {
  const { logout, payload } = useAuth();

  return (
    <div className="wrapper">
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              className="nav-link border-0 bg-transparent"
              data-widget="pushmenu"
              type="button"
            >
              <FontAwesomeIcon icon="bars" />
            </button>
          </li>
          {modules
            .filter((module) => {
              return payload && module.groups.includes(payload.group);
            })
            .map((module) => {
              return (
                <li className="nav-item" key={module.name}>
                  <Link
                    to={module.startPage ? module.startPage : `/${module.name}`}
                    className="nav-link"
                  >
                    {module.title}
                  </Link>
                </li>
              );
            })}
        </ul>
        <ul className="navbar-nav ml-auto">
          <button
            onClick={logout}
            type="button"
            className="btn btn-secondary btn-sm"
          >
            Abmelden
          </button>
        </ul>
      </nav>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <Link to="/" className="brand-link bg-light">
          <img src="/images/logo.png" alt="iib Logo" className="brand-image" />
          <span className="brand-text font-weight-light">&nbsp;</span>
        </Link>
        {moduleConfig && (
          <section className="sidebar">{moduleConfig.navigation}</section>
        )}
      </aside>
      <div className="content-wrapper">{children}</div>
    </div>
  );
}
